import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { ViewProps } from '../../../redux/theme/types'

export const Item: FunctionComponent<ViewProps> = props => <View {...props} />
